import React from 'react';
import { Grid, Box, Typography } from '@mui/material';

const AwayStatusModal = ({ awayText }) => {
    return (
        <Grid container>
            <Grid item xs={12} sm={10} md={9} lg={7} sx={{ margin: "auto" }}>
                <Box sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '24px',
                    padding: '56px 40px',
                    textAlign: 'center',
                    color: 'white',
                    boxShadow: '0 24px 80px rgba(102, 126, 234, 0.4)',
                    border: '2px solid rgba(255, 255, 255, 0.2)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-50%',
                        right: '-20%',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%)',
                        zIndex: 0,
                    }
                }}>
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                        <Typography variant="h4" sx={{
                            fontWeight: 700,
                            mb: 2.5,
                            fontSize: '2rem',
                            fontFamily: "'DM Sans', sans-serif",
                            textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                        }}>
                            📢 Notice
                        </Typography>
                        <Typography sx={{
                            fontSize: '1.25rem',
                            lineHeight: 2,
                            margin: 0,
                            textAlign: 'center',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: 400,
                            textShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                        }}>
                            {awayText}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default AwayStatusModal;
